<template>
  <div class="msg-details site-wrapper">
    <div class="guide">
      <span>您的位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }"> 首页 </el-breadcrumb-item>
        <el-breadcrumb-item>更多消息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="info" style="padding: 0;">
      <el-tabs class="newsTab" @tab-click="getDataList" v-model="activeName">
				<el-tab-pane v-for="v in msgType" :key="v.code" :label="v.val" :name="v.code"></el-tab-pane>
			</el-tabs>
      <dl v-for="v in msgInfo" :key="v.id">
        <dt>
          <img width="32px" height="32px" :src="getIcon(v.msgType)"/>
        </dt>
        <dd @click="openMore(v)">
          <h3>{{msgType.filter(vv=>vv.code == v.msgType).length>0 && msgType.filter(vv=>vv.code == v.msgType)[0].val}}&emsp;<span>{{v.createTime}}</span></h3>
          <p style="width: 1032px;" class="ellipsis">{{v.msgTitle}}</p>
        </dd>
      </dl>
      <div class="mod-page">
        <pagination layout="prev, pager, next" v-show="totalPage > 0" :total="totalPage" :page.sync="pageIndex" :limit.sync="pageLimt"
          @pagination="getDataList" />
      </div>
    </div>
    <msgDetaile v-if="msgVisible" ref="msgDetaile"></msgDetaile>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import msgDetaile from "./msgDetaile.vue";
import { dateFtt } from "@/utils";
export default {
  components: {
    Pagination,
    msgDetaile
  },
  data() {
    return {
      msgVisible:false,
      msgInfo: [{}],
      totalPage:0,
      pageIndex:1,
      pageLimt:10,
      activeName:'',
      msgType:[]
    };
  },
  created() {
    this.$http.get(this.$api.msgApi.msgType).then(({ data }) => {
      this.msgType = data.data || [];
      this.activeName = this.msgType.length>0?this.msgType[0].code:'';
      this.getDataList();
    });
  },
  methods: {
    getIcon(type){
      if(type=='XTXX'){
        return require('@/assets/img/sysRing.png')
      }
      return require('@/assets/img/sysRing1.png')
    },
    openMore(item){
      this.$http.get(this.$api.msgApi.selectMessageDetail, { params: { id: item.id } }).then(({ data }) => {
        this.msgVisible = true;
        if(!item.readSt){
          // 刷新未读数量
          this.$http.get(this.$api.pageInfoApi.getHeaderNumber).then(({ data }) => {
            this.$store.commit("updateMsgTotal", data.data.msgNum);
          });
        }
        this.$nextTick(() => {
          this.$refs.msgDetaile.init(data.data);
        })
      });
    },
    getDataList() {
      let params = {
        current: this.pageIndex,
        size: this.pageLimt,
        data: {
          creatorName: "",
          msgTitle: "",
          readSt: "",
          msgType: this.activeName
        }
      }
      this.$http.post(this.$api.msgApi.getMsg,params).then(({ data }) => {
        data.data.list.forEach(v=>{
          v.createTime = dateFtt(new Date(v.createTime));
        });
        this.msgInfo = data.data.list;
        this.totalPage = data.data.total;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.msg-details {
  position: relative;
  .info {
    min-height: 690px;
    padding: 23px 40px;
    padding-top: 0;
    background: #fff;
    border-radius: 16px;
    margin-bottom: 56px;
  }
  dl {
    display: flex;
    align-items: center;
    padding: 24px;
    border-bottom: 1px solid #F0F0F0;
    dt {
      margin-right: 8px;
      margin-top: -9px;
      img{
        vertical-align: super;
      }
    }
    dd {
      cursor: pointer;
      h3 {
        font-size: 14px;
        font-weight: bold;
        color: #333;
        span{
          font-size: 12px;
          font-weight: 400;
          color: #B3B3B3;
        }
      }
      p {
        padding-top: 10px;
        color: #666;
        line-height: 22px;
      }
    }
  }
}
::v-deep .newsTab {
    .el-tabs__active-bar {
        width: 16px!important;
        left: 23px;
    }
    .el-tabs__nav {
        padding-top: 4px;
        margin-left: 16px;
    }
    .el-tabs__item {
        padding: 0 10px;
        color: #808080;
        font-size: 16px;
        &.is-active {
            color: #333;
            font-weight: bold;
        }
    }
    .el-tabs__content {
        height: calc(100% - 49px);
        overflow: auto;
        padding-top: 16px;
    }
    .el-tabs__header {
        margin-bottom: 0px;
    }
}
</style>
